<!--
	日期：2025/08/29
	地点：四川 成都
	作者：终结司令官
	
	介绍：用户登陆界面
	
	- Powered by finalcommander.com
	- Supported by IOE.TOP
-->
<template>
	<div id="app-login" class="app-login">
		<br>
		<br>
		<br>
		<br>
		<h1 style="font-size: 32px;">广电美好生活 <br><small><small>开放平台 <small>v2.0.1</small></small></small></h1>
		<div id="login-wx" class="login-wx">微信账号认证中 ...</div>
		<div id="login-area" class="login-area">
			<el-card id="login-card" ref="login-card" class="login-card">
				<div slot="header" class="clearfix">
					<span>登陆系统</span>
					<el-button style="float: right; padding: 3px 0" type="text" @click="helpForm('loginForm')">帮助</el-button>
				</div>
				<el-form ref="loginForm" :rules="loginForm_rules" :model="loginForm_cols">
					<el-form-item label="用户" prop='username'>
						<el-input v-model="loginForm_cols.username" placeholder="请输入用户名"></el-input>
					</el-form-item>
					<el-form-item label="密码" prop='password' style="margin-bottom:10px;">
						<el-input v-model="loginForm_cols.password" placeholder="请输入密码" show-password></el-input>
					</el-form-item>
					<el-form-item prop='selLoginOption' style="margin-bottom:10px;text-align:left;">
						<el-checkbox @change="handle_selLoginOption" v-model="loginForm_cols.selLoginOption">在手机端自动登陆</el-checkbox>
					</el-form-item>
				</el-form>
				<div style="text-align: right;">
					<el-button type="secondary" @click="wxLoginForm('loginForm')">微信登陆</el-button>
					<el-button type="primary" @click="resetLoginForm('loginForm')">重 置</el-button>
					<el-button type="primary" @click="submitLoginForm('loginForm')">确 定</el-button>
				</div>
			</el-card>
			<div style="text-align: center; display:block;margin-top:27px;">
				<a class="mylink" @click="goReg('regPartner')">注册社区学员</a>
				<a class="mylink" @click="alertmsg('注册联盟企业，尚未开放！')">注册联盟企业</a>
				<a class="mylink" @click="alertmsg('注册广电员工，尚未开放！')">注册广电员工</a>
			</div>
			<div style="text-align: center; display:block;margin-top:27px;">
				Powered by IOE.TOP
			</div>
		</div>
	</div>
</template>

<script>
import { loginUser,loginUserWX } from '../api/';
//import {  } from '../utils/function.js';
import Cookies from 'js-cookie';

export default {
	name: 'app-login',
	components: {
	},
	data() {
		return {
			loginForm_cols: {
				username: '',
				password: '',
				selLoginOption: false,
			},
			loginForm_rules: {
				username: [
					{ required: true, message: "请输入用户名，不可以为空！", trigger: 'blur'},
					{ min: 3, max: 16, message: "长度必须为 6 到 15个字符！", trigger: 'blur'},
				],
				password: [
					{ required: true, message: "请输入密码，不可以为空！", trigger: 'blur'},
					{ min: 6, max: 25, message: "长度必须为 6 到 25个字符！", trigger: 'blur'},
				]
			}
		}
	},
	methods: {
		// 获得认证服务器
		get_auth_BaseUrl()
		{
			return this.$utils.getBaseUrl(true,false,false,2);
		},
		// 打开注册页面
		goReg(to2) {
			// location.href = "/#/Home";
			//this.$router.push(to2);
			//this.$router.replace(to2);
			location.href = "/#/" + to2;
		},
		// 提交按钮
		submitLoginForm(formName) {
			this.$refs[formName].validate((valid) => {
				// 提交校验正确
				if (valid) {
					let result = loginUser(this.loginForm_cols);
						
					//console.log("result:",result);
					if(parseInt(result.code) === 20000)
					{
						// 获取菜单数据，存入store中
						//const menuTemp = JSON.parse(JSON.stringify(result.data.menu));
						//Cookies.set('curUserMenu', JSON.stringify(result.data.menu));
						localStorage.setItem('curUserMenu', JSON.stringify(result.data.menu));
						result.data.menu = null;
						
						// 保存用户登陆信息
						Cookies.set('curUserLogin', JSON.stringify(result.data));
						
						//console.log(result);
						this.$store.commit('tab/setCurUserMenu', result.data.menu);
						this.$store.commit('tab/setRouterRules', { router: this.$router, menu: result.data.menu});
						
						// 获取菜单的数据，存入store中
						this.$message({
							type: 'success',
							message: '登陆成功！',
						}); 
						const thisApp = this;
						setTimeout(function() {
							//thisApp.$router.push(result.data.indexpage);
							//location.href = result.data.indexpage;
							location.href = "/#/Home";
						},50);
					}
					else
					{
						/*
						this.$message({
							type: 'error',
							message: '用户名或密码错误！'
						}); 
						*/
						this.$alert('用户名或密码错误', '登陆失败', {
						  confirmButtonText: '确定',
						  callback: action => {
							this.$message({
								type: 'error',
								message: '请核对后重新输入！'
							});
						  }
						});
					}
				} else {
					this.$message({
						type: 'error',
						message: '登陆错误！'
					});  
				}
			});
		},
		// 重置按钮
		resetLoginForm(formName) {
			this.$refs[formName].resetFields();
		},
		helpForm(formName) {
			this.$message({
				type: 'info',
				message: '在线客服已关闭，请联系管理员！',
			});  
		},
		alertmsg (message,type="info")
		{
			this.$message({
				type: type,
				message: message,
			});  
		},
		wxLoginForm(formName, type="login") {
			this.$message({
				type: 'info',
				message: '微信验证中 ... ...',
			});  
			const url = this.get_auth_BaseUrl() + "/gd/z/x/" + this.$utils.getCurrentDomain(false,false,false) + "/login/p/" + this.$utils.getProtocol() + "/auto/" + this.loginForm_cols.selLoginOption + "/for/" + type;
			//console.log("url:",url);
			location.href = url;
		},
		handle_selLoginOption() {
			if(this.loginForm_cols.selLoginOption) {
				this.$message({
					type: 'success',
					message: '在手机端自动登陆打开',
				});  
			} else {
				this.$message({
					type: 'info',
					message: '关闭在手机端自动登陆',
				});  
			}
			Cookies.set('selLoginOption', this.loginForm_cols.selLoginOption);
		}
	},
	mounted() {
	
					Cookies.remove('selLoginOption');
					Cookies.remove('curUserLogin');
					//Cookies.remove('curUserMenu');
					localStorage.removeItem('curUserMenu');
					
        // 模拟从URL参数获取来源页面
        //const urlParams = new URLSearchParams(window.location.search);
        //const at = urlParams.get('at');
		const at = this.$utils.getUrlParam('at');
        const timeout = this.$utils.getUrlParam('TIMEOUT');
		
		if (at && at !=="cancel" && at !=="error") {
			this.$message({
				type: 'info',
				message: '微信账号认证中 ...',
			}); 
			document.getElementById("login-wx").style.display = "block";
			
			let jpost = {};
			jpost.at = at;
			let result = loginUserWX(jpost);
			//console.log(result);
			
			if(parseInt(result.code) === 20000)
			{
				// 获取菜单数据，存入store中
				//const menuTemp = JSON.parse(JSON.stringify(result.data.menu));
				//Cookies.set('curUserMenu', JSON.stringify(result.data.menu));
				localStorage.setItem('curUserMenu', JSON.stringify(result.data.menu));
				result.data.menu = null;
				
				// 保存用户登陆信息
				Cookies.set('curUserLogin', JSON.stringify(result.data));
				
				//console.log(result);
				this.$store.commit('tab/setCurUserMenu', result.data.menu);
				this.$store.commit('tab/setRouterRules', { router: this.$router, menu: result.data.menu});
				
				// 获取菜单的数据，存入store中
				/* this.$message({
					type: 'success',
					message: '登陆成功！',
				}); */
				const thisApp = this;
				setTimeout(function() {
					//thisApp.$router.push(result.data.indexpage);
					location.href = "/#/Home";
				},50);
			}
			else
			{
				this.$message({
					type: 'error',
					message: '微信登陆失败！',
				}); 
				document.getElementById("login-area").style.display = "block";
			}
		}
		else if (at === "cancel") {
			this.$message({
				type: 'info',
				message: '已经取消认证！',
			}); 
			document.getElementById("login-wx").style.display = "none";
			document.getElementById("login-area").style.display = "block";
		}
		else if (at === "error") {
			this.$message({
				type: 'error',
				message: '认证错误，尚未注册！',
			}); 
			document.getElementById("login-wx").style.display = "none";
			document.getElementById("login-area").style.display = "block";
		}
		else if(timeout) {
			this.$message({
				type: 'error',
				message: '登陆超时，请重新验证身份！',
			}); 
			setTimeout(function() {
				document.getElementById("login-wx").style.display = "none";
				document.getElementById("login-area").style.display = "block";
				},1000);
		}
		// 没有at认证信息
		else {
			// 监测是否设置微信自动登陆
			if(Cookies.get('selLoginOption') === "true")
			{
				this.loginForm_cols.selLoginOption = true;
				// this.$refs[formName]
				
				// 如果在手机端设置了自动登陆
				// 则自动微信认证
				let mythis = this;
				if(this.$utils.detectDevice()<0)
				setTimeout(function(){
					mythis.$message({
						type: 'info',
						message: '微信账号自动认证中 ...',
					}); 
					mythis.wxLoginForm('loginForm');
				},500);
			}
			else
				this.loginForm_cols.selLoginOption = false;
				
			document.getElementById("login-area").style.display = "block";
			document.getElementById("login-wx").style.display = "none";
		}
	}
}
</script>

<style lang="less" Scoped>
.app-login {

	.login-area {
		width: 350px;
		/*
			margin-top: -50%;
			margin-left: -50%;
		*/
		/*
			margin: 10% auto;
		*/
		transform: translate(-50%, -50%); 
		position: fixed;
		top: 55%;
		left: 50%;
		display: none;
	}
	.login-card {
		display: ;
	}
	.login-wx {
		display: none;
	}
	.el-form-item {
	}
	.el-form-item__label {
		text-align: center;
		width: 80px;
	}
	.el-form-item__content {
		width: 220px;
		text-align: right;
	}
	.mylink {
		text-align: center;
		font-size: 0.9em;
		margin: 0px 8px;
		font-weight: 450;
		color: #999999;
	}

	/* 响应式调整 */
	@media (max-width: 768px) {
		.el-form-item {
			flex-direction: row;
		}
		.el-form-item__label {
			text-align: center;
			width: 80px;
		}
		.el-form-item__content {
			width: 220px;
			text-align: right;
		}
	}
}
</style>